<ng-container *ngIf="disableSelection || licenseTypes.length === 1 || !selectedLicenseType; else selectionEnabled">
  <div *ngIf="selectedLicenseType">
    <span>{{ getSubscriptionInterval(selectedLicenseType) | subscriptionInterval: 'subscription-short' | async }}</span>
  </div>
</ng-container>
<ng-template #selectionEnabled>
  <yat-resizing-select id="efcfeb4f-3451-4683-a748-e2f859fae85d" [formControl]="licenseTypeControl" [items]="licenseTypes" valueName="licenseTypeId">
    <ng-template let-item>
      <span>{{ getSubscriptionInterval(item) | subscriptionInterval: 'subscription-short' | async }}</span>
    </ng-template>
  </yat-resizing-select>
</ng-template>
